import { toast as toastNative } from 'react-hot-toast';

const toast = (
  message: string,
  subText = '',
  type: 'success' | 'error' | 'info' | 'warning' = 'success'
) => {
  const combinedMessage = subText ? `${message}\n${subText}` : message;
  const opts = { id: combinedMessage };
  if (type === 'error') {
    toastNative.error(combinedMessage, opts);
  } else {
    toastNative.success(combinedMessage, opts);
  }
};

export default toast;
